export default __webpack_public_path__ + "static/media/boxPolygon.005bcadf.png";